import { StudyPlan as StudyPlanModule } from '@/shared/components';

import { USER_DASHBOARD_PAGE_KEY } from '../../constants';

const StudyPlan = () => <StudyPlanModule source={USER_DASHBOARD_PAGE_KEY} />;

export default StudyPlan;
